export const getDomain = () => window.location.hostname.replace('www', '')
